import React, { FC, memo } from 'react'

import { Page, makeTraceDetails } from 'common'
import { Header, ErrorHandler } from 'components'
import { Routes } from 'common/constants'

import { useHelpCenter } from '../hooks/useHelpCenter'
import { HelpCenterView } from './HelpCenterView'

export const HelpCenter: FC = memo(() => {
  const { content, isActive } = useHelpCenter()

  if (!content || !isActive) {
    const traceDetails = makeTraceDetails(!!isActive, content)

    return (
      <ErrorHandler
        traceDetails={traceDetails}
        componentName={HelpCenter.name}
        goTo={Routes.HOME}
      />
    )
  }

  const { title } = content

  return (
    <Page>
      {title && <Header title={title} showHomeIcon homeIconRoute={Routes.HOME} />}
      <HelpCenterView content={content} />
    </Page>
  )
})
